import React, { Component } from 'react';
import './App.css';
import Header from './Header';
import Title from './Title';
import FrameAreaLeft from './FrameAreaLeft';
import FrameAreaRight from './FrameAreaRight';
import Tabs from './Tabs/Tabs';
import AdditionalInfo from './AdditionalInfo';
import Footer from './Footer';
import { connect } from 'react-redux';
import ScrollToTop from "react-scroll-up";
import {roundToTwo} from './Helpers/Helpers';
import ReactPixel from 'react-facebook-pixel';

class App extends Component {

    constructor(props) {
        super(props)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.getFrameSize = this.getFrameSize.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        this.getFrameSize();
        window.addEventListener('resize', this.updateWindowDimensions);
        ReactPixel.init('750285538674235');
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevProps.selectedFrame !== this.props.selectedFrame || prevProps.frameImageHeight !== this.props.frameImageHeight || prevProps.frameImageWidth !== this.props.frameImageWidth || prevProps.selectedTopMat !== this.props.selectedTopMat || prevProps.selectedMiddleMat !== this.props.selectedMiddleMat || prevProps.selectedBottomMat !== this.props.selectedBottomMat || prevProps.selectedTopMatValueInCM !== this.props.selectedTopMatValueInCM || prevProps.selectedMiddleMatValueInCM !== this.props.selectedMiddleMatValueInCM || prevProps.selectedBottomMatValueInCM !== this.props.selectedBottomMatValueInCM || prevProps.selectedMatSize !== this.props.selectedMatSize || prevProps.framedCalc !== this.props.framedCalc ) {
            this.getFrameSize();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                viewportWidth: window.innerWidth,
                viewportHeight: window.innerHeight
            }
        })
    }

    getFrameSize() {
        const {frameImageWidth, frameImageHeight, selectedMatSize, selectedTopMatValueInCM, selectedMiddleMatValueInCM, selectedBottomMatValueInCM, selectedTopMat, selectedMiddleMat, selectedBottomMat, selectedFrame, framedCalc} = this.props;
        const dimensions = selectedFrame.get('dimensions');
        if (dimensions !== undefined) {
            let frameWidthNew = parseFloat(frameImageWidth) + (parseFloat(dimensions.get('width')) * 2);
            let frameHeightNew = parseFloat(frameImageHeight) + (parseFloat(dimensions.get('width')) * 2);
            let matDimension = 0;

            switch (parseFloat(selectedMatSize)) {
                case 1:
                    matDimension = (parseFloat(selectedTopMatValueInCM) * 2);
                    break;
                case 2:
                    matDimension = (parseFloat(selectedTopMatValueInCM) * 2) + (parseFloat(selectedMiddleMatValueInCM) * 2);
                    break;
                case 3:
                    matDimension = (parseFloat(selectedTopMatValueInCM) * 2) + (parseFloat(selectedMiddleMatValueInCM) * 2) + (parseFloat(selectedBottomMatValueInCM) * 2);
                    break;
                default:
            }

            frameWidthNew = frameWidthNew + matDimension;
            frameHeightNew = frameHeightNew + matDimension;

            this.props.dispatch({
                type: 'SET_STATE',
                state: {
                    frameSizeH: roundToTwo(frameHeightNew - 1) ,
                    frameSizeW: roundToTwo(frameWidthNew - 1),
                    frameFullDimension: parseFloat(frameImageWidth) + parseFloat(frameImageHeight)
                }
            })

            // Mats calculations
            let frameFullDimension = parseFloat(frameImageWidth) + parseFloat(frameImageHeight);

            // Top Mat
            if (selectedTopMat.size > 0) {
                const price = parseFloat(selectedTopMat.getIn(['acf', 'price']));
                const output = ( parseFloat(price) * ( frameFullDimension + ( parseFloat(selectedTopMatValueInCM) * 4 ) ) );
                this.props.dispatch({
                    type: 'SET_STATE',
                    state: {
                        topMatTotal: output.toFixed(2)
                    }
                })
            }

            // Middle Mat
            if (selectedMiddleMat.size > 0) {
                const mPrice = parseFloat(selectedMiddleMat.getIn(['acf', 'price']));
                const output = mPrice * ( frameFullDimension + ( ( parseFloat(selectedTopMatValueInCM) * 4 ) + ( parseFloat(selectedMiddleMatValueInCM)) * 4 ) );
                this.props.dispatch({
                    type: 'SET_STATE',
                    state: {
                        middleMatTotal: output.toFixed(2)
                    }
                })
                if (parseFloat(selectedMatSize) === 2) {
                    this.props.dispatch({
                        type: 'SET_STATE',
                        state: {
                            topMatTotal: output.toFixed(2)
                        }
                    })
                }
            }

            // Bottom Mat
            if (selectedBottomMat.size > 0) {
                const bPrice = parseFloat(selectedBottomMat.getIn(['acf', 'price']));
                const output = bPrice * ( frameFullDimension + ( ( parseFloat(selectedTopMatValueInCM) * 4 ) + ( parseFloat(selectedMiddleMatValueInCM) * 4 ) + ( parseFloat(selectedBottomMatValueInCM)) * 4 ) );
                this.props.dispatch({
                    type: 'SET_STATE',
                    state: {
                        bottomMatTotal: output.toFixed(2)
                    }
                })
                if (parseFloat(selectedMatSize) === 3) {
                    this.props.dispatch({
                        type: 'SET_STATE',
                        state: {
                            topMatTotal: output.toFixed(2),
                            middleMatTotal: output.toFixed(2),
                        }
                    })
                }
            }

            // Frame Price Calculations
            const priceFrame = selectedFrame.get('price'); // Frame Price
            let frameFullDimensionFrame = parseFloat(frameImageWidth) + parseFloat(frameImageHeight) + matDimension; // Frame width + height + mat
            if (priceFrame !== undefined && frameFullDimensionFrame !== 0) {
                let outputFrame = 0;
                if (frameFullDimensionFrame < 105)
                    outputFrame = frameFullDimensionFrame * parseFloat(priceFrame);
                else if (frameFullDimensionFrame >= 105 && frameFullDimensionFrame < 140)
                    outputFrame = (frameFullDimensionFrame * 0.16) + (frameFullDimensionFrame * parseFloat(priceFrame));
                else if (frameFullDimensionFrame >= 140 && frameFullDimensionFrame < 200)
                    outputFrame = (frameFullDimensionFrame * 0.25) + (frameFullDimensionFrame * parseFloat(priceFrame));
                else if (frameFullDimensionFrame >= 200)
                    outputFrame = (frameFullDimensionFrame * 0.33) + (frameFullDimensionFrame * parseFloat(priceFrame));

                // For adding additional price to style based on framed size
                const framedFullSize = roundToTwo(frameWidthNew) + roundToTwo(frameHeightNew)
                const framed_size = framedCalc.getIn(['acf', 'framed_size'])

                if (undefined !== framed_size) {
                    for (var i = 0; i < framed_size.size; i++) {
                        const w_h_from = parseFloat(framed_size.getIn([i, 'w_h_from']))
                        const w_h_to = parseFloat(framed_size.getIn([i, 'w_h_to']))
                        const rate = framed_size.getIn([i, 'rate'])

                        //console.log(roundToTwo(frameWidthNew), 'frameWidthNew')
                        //console.log(roundToTwo(frameHeightNew), 'frameHeightNew')
                        //console.log(roundToTwo(framedFullSize), 'framedFullSize')
                        //console.log(w_h_from, 'w_h_from')
                        //console.log(w_h_to, 'w_h_to')

                        if ( (roundToTwo(framedFullSize) >= w_h_from && roundToTwo(framedFullSize) <= w_h_to ) || (roundToTwo(framedFullSize) >= w_h_from && isNaN(w_h_to) ) ) {
                            outputFrame = parseFloat(outputFrame) + parseFloat(rate);
                            break;
                        }
                    }
                }
                // For adding additional price to style based on framed size

                this.props.dispatch({
                    type: 'SET_STATE',
                    state: {
                        frameTotal: outputFrame.toFixed(2)
                    }
                });
            }
        }
    }

    render() {
        return (
            <div className="main-content-outer">
                <div className="container-fluid">
                    <div className="row">
                        <Header {...this.props} />
                        <Title {...this.props} />
                        <div className="farme_cust full_width">
                            <div className="container">
                                <div className="row">
                                    <FrameAreaLeft {...this.props} />
                                    <FrameAreaRight {...this.props} />
                                </div>
                            </div>
                        </div>
                        <Tabs {...this.props} />
                        <AdditionalInfo />
                        <Footer {...this.props} />
                        <ScrollToTop showUnder={100}>
                            <button title='Back to top' className='scroll'>
                                <span className='arrow-up glyphicon glyphicon-chevron-up'></span>
                            </button>
                        </ScrollToTop>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        frameProducts: state.get('frameProducts'),
        productsCount: state.get('productsCount'),
        frameCategories: state.get('frameCategories'),
        displayCategory: state.get('displayCategory'),
        catProCount: state.get('catProCount'),
        frameLoading: state.get('frameLoading'),
        selectedFrame: state.get('selectedFrame'),
        frameImage: state.get('frameImage'),
        frameTotal: state.get('frameTotal'),
        frameSizeH: state.get('frameSizeH'),
        frameSizeW: state.get('frameSizeW'),
        frameFullDimension: state.get('frameFullDimension'),
        canvasImage: state.get('canvasImage'),
        canvasThumbImage: state.get('canvasThumbImage'),
        frameImageHeight: state.get('frameImageHeight'),
        frameImageWidth: state.get('frameImageWidth'),
        uploadedImageHeight: state.get('uploadedImageHeight'),
        uploadedImageWidth: state.get('uploadedImageWidth'),
        imageSizeError: state.get('imageSizeError'),
        aspectRatio: state.get('aspectRatio'),
        framedCalc: state.get('framedCalc'),

        glasses: state.get('glasses'),
        selectedGlass: state.get('selectedGlass'),
        glassTotal: state.get('glassTotal'),
        selectedGlassName: state.get('selectedGlassName'),

        backings: state.get('backings'),
        selectedBacking: state.get('selectedBacking'),
        backingTotal: state.get('backingTotal'),
        selectedBackingName: state.get('selectedBackingName'),

        printing: state.get('printing'),
        selectedPrint: state.get('selectedPrint'),
        printTotal: state.get('printTotal'),
        selectedPrintName: state.get('selectedPrintName'),

        wallcolor: state.get('wallcolor'),

        roomImages: state.get('roomImages'),
        selectedRoomImage: state.get('selectedRoomImage'),

        libraryImageUploading: state.get('libraryImageUploading'),

        mats: state.get('mats'),
        matView: state.get('matView'),
        selectedTopMat: state.get('selectedTopMat'),
        selectedMiddleMat: state.get('selectedMiddleMat'),
        selectedBottomMat: state.get('selectedBottomMat'),
        selectedTopMatValueInCM: state.get('selectedTopMatValueInCM'),
        selectedMiddleMatValueInCM: state.get('selectedMiddleMatValueInCM'),
        selectedBottomMatValueInCM: state.get('selectedBottomMatValueInCM'),
        selectedMatSize: state.get('selectedMatSize'),
        topMatTotal: state.get('topMatTotal'),
        middleMatTotal: state.get('middleMatTotal'),
        bottomMatTotal: state.get('bottomMatTotal'),
        matsLoaded: state.get('matsLoaded'),

        qty: state.get('qty'),
        cartQty: state.get('cartQty'),
        customizeQTY: state.get('customizeQTY'),
        cart1ItemTotal: state.get('cart1ItemTotal'),
        uploadedFile: state.get('uploadedFile'),
        selectedTab: state.get('selectedTab'),

        viewportWidth: state.get('viewportWidth'),
        viewportHeight: state.get('viewportHeight'),
        rightFrameHeight: state.get('rightFrameHeight'),

        showMeHow: state.get('showMeHow'),
    }
}

export default connect(mapStateToProps)(App);